"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Separator } from "@/components/ui/separator";
import { Twitter, Linkedin, Github, ArrowUpRight } from "lucide-react";
const regionalLinks = [{
  label: "Lending Solutions",
  to: "/LendingSolutionsPage"
}, {
  label: "Our Advisors",
  to: "/OurAdvisorsPage"
}, {
  label: "Current Rates",
  to: "#"
}];
const companyLinks = [{
  label: "About Beacon",
  to: "#"
}, {
  label: "Privacy Policy",
  to: "#"
}, {
  label: "Contact Us",
  to: "/ContactPage"
}];
const socialLinks = [{
  icon: Twitter,
  to: "#",
  label: "Twitter"
}, {
  icon: Linkedin,
  to: "#",
  label: "LinkedIn"
}, {
  icon: Github,
  to: "#",
  label: "GitHub"
}];
const tickerItems = ["NMLS #1928374", "EQUAL HOUSING LENDER", "CONVENTIONAL LOANS", "FHA SPECIALISTS", "VA HOME LOANS", "REFINANCE EXPERTS", "JUMBO MORTGAGES", "HOME EQUITY LINES", "FIXED RATE 30-YEAR", "ADJUSTABLE RATE MORTGAGES"];
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="264915" id="footer" className="bg-background text-foreground pt-16 overflow-hidden flex flex-col border-t-4 border-primary">
      <style>{`
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-ticker {
          animation: ticker 40s linear infinite;
          display: flex;
          width: max-content;
        }
        .animate-ticker:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="container mx-auto px-4 md:px-6 lg:px-8 mb-16 flex-grow">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="h-8 w-auto text-primary" />
            </Link>
            <p className="text-foreground font-mono text-[10px] leading-relaxed max-w-xs mb-6 uppercase tracking-wider">
              Beacon Finance Group. NMLS ID #1928374. Licensed in all 50 states. Providing secure mortgage solutions with guided clarity and architectural precision.
            </p>
            <p className="text-foreground font-mono text-[10px] mt-auto">
              © {currentYear} BEACON FINANCE GROUP.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-lg mb-6 tracking-tight text-primary uppercase">Services</h3>
            <ul className="space-y-4">
              {regionalLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.to} className="text-foreground hover:text-primary transition-colors text-sm font-medium flex items-center group">
                    {link.label}
                    <ArrowUpRight className="ml-1 size-3 opacity-0 -translate-y-1 translate-x-1 group-hover:opacity-100 group-hover:translate-y-0 group-hover:translate-x-0 transition-all duration-300" />
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-lg mb-6 tracking-tight text-primary uppercase">Company</h3>
            <ul className="space-y-4">
              {companyLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.to} className="text-foreground hover:text-primary transition-colors text-sm font-medium flex items-center group">
                    {link.label}
                    <ArrowUpRight className="ml-1 size-3 opacity-0 -translate-y-1 translate-x-1 group-hover:opacity-100 group-hover:translate-y-0 group-hover:translate-x-0 transition-all duration-300" />
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-lg mb-6 tracking-tight text-primary uppercase">Connect</h3>
            <div className="flex gap-4 mb-6">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} data-index={i} to={social.to} aria-label={social.label} className="bg-muted hover:bg-primary hover:text-primary-foreground text-primary p-2.5 rounded-md transition-all duration-300 shadow-sm">
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
            <p className="text-foreground font-mono text-[10px] uppercase">
              Contact: (800) 555-BEAC<br />
              Email: hello@beaconfinance.com
            </p>
          </div>
        </div>
      </div>

      {}
      <Separator className="w-full bg-border" />

      {}
      <div className="w-full overflow-hidden bg-background py-4">
        <div className="animate-ticker flex items-center">
          {}
          {[...tickerItems, ...tickerItems].map((item, i) => <div key={i} data-index={i} className="flex items-center shrink-0">
              <span className="font-mono text-[10px] md:text-xs tracking-widest text-foreground whitespace-nowrap uppercase px-4">
                {item}
              </span>
              <span className="text-primary/20 text-xs">/</span>
            </div>)}
        </div>
      </div>
    </section>;
}